/**
 * エントリー管理機能で使用するエラーメッセージ定数
 */

import {MAX_TEXT_INPUT_LENGTH, MAX_UPLOAD_FILE_SIZE_MB} from './inputLimits';

export const ERROR_MESSAGES = {
  STEP_SAVE_FAILED: {
    title: '選考予定の保存に失敗',
    message: '保存に失敗しました。もう一度お試しください',
  },
  STEP_INPUT_ERROR: {
    title: '入力エラー',
    message: '企業名と選考予定は必須です',
  },
  ENTRY_MANAGEMENT_SAVE_FAILED: {
    title: '選考管理の追加に失敗',
    message: '保存に失敗しました。もう一度お試しください',
  },
  FILE_SIZE_LIMIT_EXCEEDED: `ファイルサイズは${MAX_UPLOAD_FILE_SIZE_MB}MB以下にしてください`,
  TEXT_LENGTH_LIMIT_EXCEEDED: `入力テキストが長すぎます（${MAX_TEXT_INPUT_LENGTH.toLocaleString()}文字以内）`,
} as const;

export const SUCCESS_MESSAGES = {
  STEP_SAVED: (stepName: string) => ({
    title: '選考予定を保存しました',
    message: `「${stepName}」を追加しました`,
  }),
  ENTRY_MANAGEMENT_SAVED: {
    title: '選考管理を追加しました',
    message: '進捗管理を正常に保存しました',
  },
} as const;
